<template>
  <v-container class="px-10" style="max-width: 1600px !important;">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <v-dialog max-width="65%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_horario_acceso === null ? "Crear" : "Editar" }} Horario Acceso
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="editedItem.dia_semana"
                label="Día de la Semana"
                dense
                hide-details
                outlined
                :items="diasSemanaFiltrados"
              />
            </v-col>

            <v-col cols="6">
              <v-menu
                style="z-index: 1100 !important;"
                ref="menuDesde"
                v-model="menuDesde"
                :close-on-content-click="false"
                :return-value.sync="editedItem.desde"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.desde"
                    label="Desde"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-model="editedItem.desde"
                  full-width
                  format="24hr"
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="$refs.menuDesde.save(editedItem.desde)">Aceptar</v-btn>
                </v-time-picker>
              </v-menu>
            </v-col>

            <v-col cols="6">
              <v-menu
                style="z-index: 1100 !important;"
                ref="menuHasta"
                v-model="menuHasta"
                :close-on-content-click="false"
                :return-value.sync="editedItem.hasta"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.hasta"
                    label="Hasta"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-model="editedItem.hasta"
                  full-width
                  format="24hr"
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="$refs.menuHasta.save(editedItem.hasta)">Aceptar</v-btn>
                </v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="saving">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Horario</v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar el Horario del día {{ editedItem.label_dia_semana }}? Esta acción es permanente y no se puede revertir.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="deleting">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" v-if="diasSemanaFiltrados.length > 0">
        <v-btn color="primary" @click="openDialogAddEdit(null)">Crear Horario</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :items-per-page="-1"
          :headers="headers"
          :items="items"
          hide-default-footer
          :loading="loading"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogAddEdit(item)">mdi-pencil</v-icon>
            <v-icon small class="mr-2" @click="openDialogDelete(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    headers: [
      { text: 'Día de la Semana', value: 'label_dia_semana', align: 'center', sortable: false },
      { text: 'Desde', value: 'desde', align: 'center', sortable: false },
      { text: 'Hasta', value: 'hasta', align: 'center', sortable: false },
      { text: 'Acciones', value: 'actions', align: 'center', width: '20%', sortable: false }
    ],
    items: [],
    loading: false,
    diasSemana: [
      { value: 0, text: 'Domingo' },
      { value: 1, text: 'Lunes' },
      { value: 2, text: 'Martes' },
      { value: 3, text: 'Miércoles' },
      { value: 4, text: 'Jueves' },
      { value: 5, text: 'Viernes' },
      { value: 6, text: 'Sábado' }
    ],
    diaSemanaEdited: -1,
    editedItem: { id_horario_acceso: null, dia_semana: null, label_dia_semana: null, desde: null, hasta: null },
    defaultEditedItem: { id_horario_acceso: null, dia_semana: null, label_dia_semana: null, desde: null, hasta: null },
    dialogAddEdit: false,
    dialogDelete: false,
    saving: false,
    deleting: false,
    menuDesde: false,
    menuHasta: false
  }),
  computed: {
    diasSemanaFiltrados() {
      return this.diasSemana.filter(x => (this.diaSemanaEdited >= 0 && this.diaSemanaEdited === x.value) || !this.items.map(y => y.dia_semana).includes(x.value));
    }
  },
  mounted() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.loading = true;
      axios.get('/HorarioAcceso/Listar')
        .then(response => { this.items = response.data; })
        .catch(console.error)
        .finally(() => { this.loading = false; });
    },
    openDialogAddEdit(editItem = null) {
      if (editItem) {
        this.diaSemanaEdited = editItem.dia_semana;
        this.editedItem = Object.assign({}, editItem);
      } else {
        this.editedItem = Object.assign({}, this.defaultEditedItem);
        this.diaSemanaEdited = -1;
      }
      this.dialogAddEdit = true;
    },
    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
      this.diaSemanaEdited = -1;
    },
    saveDialogAddEdit() {
      if (this.editedItem.dia_semana == null || !this.editedItem.desde || !this.editedItem.hasta) {
        this.$refs.alert.setMessage('', 'Debe llenar todos los campos.');
        this.$refs.alert.open();
        return;
      }

      const [h1, m1] = this.editedItem.desde.split(':').map(Number);
      const [h2, m2] = this.editedItem.hasta.split(':').map(Number);
      const minutosDesde = h1 * 60 + m1;
      const minutosHasta = h2 * 60 + m2;

      if (minutosDesde >= minutosHasta) {
        this.$refs.alert.setMessage('', "La hora 'Desde' debe ser menor que la hora 'Hasta'.");
        this.$refs.alert.open();
        return;
      }

      this.saving = true;
      axios.post('/HorarioAcceso/CrearActualizar', {
        id_horario_acceso: this.editedItem.id_horario_acceso,
        dia_semana: this.editedItem.dia_semana,
        desde: this.editedItem.desde,
        hasta: this.editedItem.hasta
      })
      .then(() => {
        this.getItems();
        this.closeDialogAddEdit();
      })
      .catch(error => {
        if (error.response?.status === 409) {
          this.$refs.alert.setMessage('', 'Existe un horario con el mismo día.');
          this.$refs.alert.open();
        }
      })
      .finally(() => { this.saving = false; });
    },
    openDialogDelete(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },
    saveDialogDelete() {
      this.deleting = true;
      axios.delete(`/HorarioAcceso/Eliminar/${this.editedItem.id_horario_acceso}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch(console.error)
        .finally(() => { this.deleting = false; });
    }
  }
}
</script>
